import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Customer route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} CustomerRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - Indicates whether the route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/customers",
        name: "Customers",
        meta: {
            title: "Customers",
            modules: ["customers"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },

        component: () =>
            import(
                /* webpackChunkName: "customers" */ "@/modules/customers/pages/Customers"
            )
    },
    {
        path: "/customers/new",
        name: "NewCustomer",
        component: () =>
            import(
                /* webpackChunkName: "customers" */ "@/modules/customers/pages/NewCustomer"
            ),
        meta: {
            title: "New Customer",
            modules: ["customers"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        }
    },
    {
        path: `/customers/${idParam()}`,
        name: "CustomerProfile",
        meta: {
            title: "Customer Profile",
            modules: ["customers"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "customers" */ "@/modules/customers/pages/CustomerProfile"
            )
    }
]